import { render, staticRenderFns } from "./SourceManagement.vue?vue&type=template&id=a1c0146e&scoped=true"
import script from "./SourceManagement.vue?vue&type=script&lang=js"
export * from "./SourceManagement.vue?vue&type=script&lang=js"
import style0 from "./SourceManagement.vue?vue&type=style&index=0&id=a1c0146e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1c0146e",
  null
  
)

export default component.exports